import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Blog, { BlogDataType } from '@components/blog';

const query = graphql`
  query CaseStudiesIndexQuery {
    prismicCaseStudiesIndex {
      ...CaseStudiesIndexData
    }
  }
`;

const CaseStudiesIndexPage: React.FC = (): JSX.Element | null => {
  const data = useStaticQuery<{ prismicCaseStudiesIndex: BlogDataType | null }>(query);
  const { prismicCaseStudiesIndex } = data;

  if (!prismicCaseStudiesIndex) {
    // Skip rendering if there is no case studies index data available.
    return null;
  }

  return <Blog data={prismicCaseStudiesIndex.data} postsType="case_studies_post" />;
};

export default CaseStudiesIndexPage;
